import { useMutation, useQueryClient } from 'react-query'

import StepService from 'src/services/steps.service'
import { IStepCancelAccountConnectionUpdateDto } from 'src/types'
import { QUERY_KEYS } from 'src/constants'

export const useCancelStepAccountConnectionUpdate = () => {
  const queryClient = useQueryClient()

  return useMutation(
    (dto: IStepCancelAccountConnectionUpdateDto) =>
      StepService.cancelStepAccountConnectionUpdate(dto),
    {
      onSuccess: async (_, vars) => {
        queryClient.invalidateQueries(QUERY_KEYS.STEPS)
        await queryClient.invalidateQueries([QUERY_KEYS.ACCOUNT_STEPS_CONNECTION, vars.id])
      },
    },
  )
}
